import React from 'react'
import PlantSlider from './PlantSlider'
import PlantGallery from './PlantGallery'

function Gallery() {
    return (
        <div className='d-grid gap-5 pb-5'>
            {/* <Banner title={"Gallery"} image={require('../../assets/images/gallery.png')} /> */}
            <PlantSlider />
            <PlantGallery />
        </div>
    )
}

export default Gallery